import LinkedAccountSourceTemplate from '@/features/agent/linked_accounts/templates/LinkedAccountSourceTemplate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/agent/linked_accounts/new/$sourceType')({
  component: LinkedAccountNewSource,
  staticData: { title: '連携先追加' },
});

function LinkedAccountNewSource() {
  const { sourceType } = Route.useParams();

  return <LinkedAccountSourceTemplate sourceType={sourceType} />;
}
